import { render, staticRenderFns } from "./fwdd.vue?vue&type=template&id=48f40e28&scoped=true&"
import script from "./fwdd.vue?vue&type=script&lang=js&"
export * from "./fwdd.vue?vue&type=script&lang=js&"
import style0 from "./fwdd.vue?vue&type=style&index=0&id=48f40e28&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f40e28",
  null
  
)

export default component.exports